<template>
  <div v-if="showModal" class="modal-overlay" @click.self="closeModal">
    <div class="modal-content">
      <!-- Added close button -->
      <button class="close-button" @click="closeModal">X</button>
      <h2>輸入車號</h2>
      <input type="text"
             v-model="lpNumber"
             ref="lpInput" 
             placeholder="請輸入車號(最多8碼)..."
             class="lp-input"
             maxlength="8"
             @input="formatInput" />
      <button class="apply-button" @click="submitLPNumber">
        加入車號
      </button>
    </div>
  </div>
</template>

<script>
// import { nextTick } from 'vue';

export default {
  data() {
    return {
      showModal: true,
      lpNumber: '',
    };
  },
  mounted() {
    // Focus the input right after modal is shown
    this.$nextTick(() => {
      this.$refs.lpInput.focus();
    });
  },
  methods: {
    closeModal() {
      this.$emit('close-modal');
    },
    formatInput() {
      // Force input to uppercase and allow only A-Z and 0-9
      this.lpNumber = this.lpNumber.toUpperCase().replace(/[^A-Z0-9]/g, '');
    },
    submitLPNumber() {
      if (!this.lpNumber || this.lpNumber.length > 8) {
        alert('請輸入最多8位的有效車號（數字或大寫字母）。');
        return;
      }
      this.$emit('lp-number-entered', this.lpNumber);
    },
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  z-index: 2000;
}

.modal-content {
  background-color: white;
  border-radius: 10px;
  width: 640px;
  padding: 24px 30px;
  position: relative;
  text-align: center;

  display: flex;
  flex-direction: column;
  align-items: center;

  margin-top: 80px;

  box-sizing: border-box;
}

h2 {
  font-size: 48px;
  line-height: 33.6px;
  color: var(--green03);
  margin-top: 0px;
  margin-bottom: 68px;
}

.lp-input {
  padding: 10px;
  font-size: 40px;
  width: 80%;
  margin: 20px 0;
  text-align: center;
  text-transform: uppercase;

  border: 2px solid var(--gray15);
  border-radius: 10px;
}

.apply-button {
  min-height: 48px;
  padding: 20px 32px 20px 32px;
  border-radius: 99px;

  background-color: var(--green03);
  color: white;
  border: none;

  margin-top: 32px;
  margin-bottom: 32px;

  font-family: Inter;
  font-size: 28px;
  font-weight: 700;
  line-height: 26.1px;
  text-align: center;

  box-sizing: border-box;
}

.apply-button:hover {
  background-color: var(--green02);
}

.apply-button:focus {
  outline: none;
  background-color: var(--green02);
}

/* Added styles for close button */
.close-button {
  position: absolute;
  top: 16px;
  right: 20px;
  background: transparent;
  border: none;
  font-size: 40px;
  cursor: pointer;
}

/* Responsive Styles */
@media (max-width: 560px) {
  .modal-content {
    width: 343px;
    padding: 20px 20px;
  }

  h2 {
    font-family: Inter;
    font-size: 28px;
    font-weight: 700;
    line-height: 30px;
    text-align: center;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;

    margin-top: 0px;
    margin-bottom: 40px;
  }

  .apply-button {
    padding: 0px 20px;
    border-radius: 99px;

    margin-top: 20px;
    margin-bottom: 32px;

    font-size: 14px;
    line-height: 21.56px;
  }

  .lp-input {
    font-size: 16px;
    width: 80%;
    margin: 20px 0;
  }

  .close-button {
    top: 20px;
    right: 20px;
    font-size: 24px;
  }
}
</style>
